module.exports = __webpack_public_path__ + "img/ssl-certificate-icon.972837be.png";